export const FEATURE_BULK_ACTIONS_V2 = 'FEATURE_BULK_ACTIONS_V2';
export const RECURRING_INVOICES_FEATURE_FLAG_ID = 'grandfather_recurring_invoices';
